import i18next from 'i18next'
import { loadingAsyncState } from 'widgets-for-react'
import { TypeCastingValidator, canSafelyCast } from '../../../utils/safe-type-casting'
import { imageValidator } from '../image/imageApi'
import { SharepointPageData } from './sharepointPageState'

async function getSharepointPageData(slug: string): Promise<any> {
  const language = i18next.language
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/SharePoint/page/${slug}?language=${language}`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) throw Error(res.statusText)

  const fields = (await res.json()).ListItemAllFields

  return {
    ContentType: fields.ContentType.Name,
    CanvasContent1: fields.CanvasContent1,
    HeaderDescription: fields.HeaderDescription || '',
    HeaderImage: {
      Title: fields.HeaderImage ? fields.HeaderImage.Description || '' : '',
      Url: fields.HeaderImage ? fields.HeaderImage.Url || '' : '',
    },
    HeaderTitle: fields.HeaderTitle || '',
    Id: fields.Id,
    PublicationDateBegin: fields.PublicationDateBegin,
    Public: fields.Public || false,
    SubscriptionTypesId: fields.SubscriptionTypesId,
    BrandId: fields.BrandId || 0,
  }
}

const sharepointPageDataValidator: TypeCastingValidator<SharepointPageData> = {
  kind: 'object',
  fieldsValidator: {
    ContentType: { kind: 'string' },
    CanvasContent1: { kind: 'string' },
    HeaderDescription: { kind: 'string' },
    HeaderImage: imageValidator,
    HeaderTitle: { kind: 'string' },
    Id: { kind: 'number' },
    PublicationDateBegin: { kind: 'string' },
    Public: { kind: 'boolean' },
    SubscriptionTypesId: {
      kind: 'array',
      elementValidator: { kind: 'number' },
    },
    BrandId: { kind: 'number' },
  },
}

export const loadSharepointPageData = (slug: string) =>
  loadingAsyncState(() =>
    getSharepointPageData(slug).then((raw) => {
      const maybePageData = canSafelyCast<SharepointPageData>(
        sharepointPageDataValidator,
        raw
      )
      return maybePageData.kind == 'r'
        ? { kind: 'result', value: maybePageData.v, status: 200 }
        : { kind: 'failed', status: 404 }
    })
  )

export async function getSponsorData(id: number): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(`/api/v1/brand/${id}`, {
    method: 'get',
    headers: headers,
  })
  if (!res.ok) throw Error(res.statusText)
  return await res.json()
}
